import * as React from "react";

export type FieldLabels = string[] | { label: string; span: number; minWidth?: number }[];

interface Props {
  fieldLabels?: FieldLabels;
  className?: string;
  columnCount?: number;
  hasRemoveButton?: boolean;
  ng?: boolean;
}
export const FormListFieldLabels: React.FC<Props> = ({
  fieldLabels = [],
  className = "",
  columnCount: _columnCount,
  hasRemoveButton,
  ng,
}) => {
  if (fieldLabels.length < 1) {
    return null;
  }

  const columnCount = React.useMemo(() => {
    if (_columnCount !== undefined) {
      return _columnCount;
    }

    let acc = 0;

    let useLengthOfLabels = false;
    for (const fieldLabel of fieldLabels) {
      if (typeof fieldLabel === "string") {
        useLengthOfLabels = true;
        break;
      }
      acc += fieldLabel.span;
    }

    if (useLengthOfLabels) {
      return fieldLabels.length;
    }

    return acc;
  }, []);

  return (
    <>
      <div
        className={`gap-2 ${className}`}
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columnCount}, 1fr) ${hasRemoveButton ? "32px" : ""}`,
        }}
      >
        {fieldLabels.map((field) => {
          const span = typeof field === "string" ? `col-span-1` : `col-span-${field.span}`;
          const value = typeof field === "string" ? field : field.label;

          return (
            <div
              className={`${span} ${ng ? `text-xs cpln-ant-form-item-description font-semibold` : ""}`}
              key={value}
              style={field.minWidth ? { minWidth: field.minWidth } : undefined}
            >
              {ng ? value.toUpperCase() : value}
            </div>
          );
        })}
        {hasRemoveButton ? <div className="col-span-1" style={{ minWidth: 32, height: "100%" }} /> : null}
      </div>
    </>
  );
};
